import { useState, useEffect } from 'react';
import { getMe, login as apiLogin, logout as apiLogout } from '../api/client.js';
import type { LoginResponse } from '../api/client.js';

interface AuthState {
  user: LoginResponse['user'] | null;
  isAuthenticated: boolean;
  isLoading: boolean;
}

export function useAuth() {
  const [state, setState] = useState<AuthState>({
    user: null,
    isAuthenticated: false,
    isLoading: true,
  });

  useEffect(() => {
    getMe()
      .then((res) => {
        setState({ user: res.user, isAuthenticated: true, isLoading: false });
      })
      .catch(() => {
        setState({ user: null, isAuthenticated: false, isLoading: false });
      });
  }, []);

  const login = async (username: string, password: string) => {
    const res = await apiLogin(username, password);
    setState({ user: res.user, isAuthenticated: true, isLoading: false });
  };

  const logout = async () => {
    await apiLogout();
    setState({ user: null, isAuthenticated: false, isLoading: false });
  };

  return { ...state, login, logout };
}
